import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { cardQueries } from '../queries/card-queries.js';
import { deleteCard } from '../requests/delete-card.js';

export const useDeleteCardMutation = (): UseMutationResult<void, Error, string> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCard,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: cardQueries.lists() }),
  });
};
